import React from 'react'
import { useSelector } from 'react-redux'
import { Avatar, Button, Typography } from '@mui/material'
import { useGlobalStyles } from '~shared/styles/globalStyles'
import Row from '~shared/components/MuiGrid/Row'
import Col from '~shared/components/MuiGrid/Col'
import GridContainer from '~shared/components/MuiGrid/GridContainer'
import { useAccountStyles } from '../Account.styles'
import { getAccountInfo, getUser } from '~store/account/selectors'
import { editProfile, forgotPassword } from '~utils/msal/msalAuthentication'
import { useTranslation } from 'react-i18next'

const Profile: React.FC = () => {
  const s = useAccountStyles()
  const gs = useGlobalStyles()
  const { t } = useTranslation()

  const accountInfo = useSelector(getAccountInfo)
  const user = useSelector(getUser)

  return <GridContainer gridSpacing={3} defaultColWidth={12} elevation={1} squareCornersTop maxWidth='Md'>
    <Row spacingTop={3}>
      <Col>
        <div className={gs.flex}>
          <Avatar className={s.avatar}>
            {`${user?.firstName.charAt(0).toUpperCase()}${user?.lastName.charAt(0).toUpperCase()}`}
          </Avatar>
          <div className={gs.marginLeftTiny}>
            <Typography>{`${accountInfo?.idTokenClaims?.given_name} ${accountInfo?.idTokenClaims?.family_name}`}</Typography>
            <Typography>{`${accountInfo?.idTokenClaims?.email}`}</Typography>
          </div>
        </div>
      </Col>
    </Row>
    <Row>
      <Col>
        <Button
          onClick={editProfile}
          variant='contained'
          color='secondary'
        >
          <Typography component='span'>{t('form:changeName')}</Typography>
        </Button>
      </Col>
    </Row>
    <Row>
      <Col>
        <Button
          onClick={forgotPassword}
          variant='contained'
          color='secondary'
        >
          <Typography component='span'>{t('form:changePassword')}</Typography>
        </Button>
      </Col>
    </Row>
  </GridContainer>
}

export default Profile
